module.exports = __webpack_public_path__ + "img/login-bg.2de31ad8.png";